import { useTranslation } from 'react-i18next';
import { formatDayMonth } from '../../lib/format';

/**
 * A dashboard section heading that states its period.
 *
 * When a reporting baseline is set, every figure below it silently excludes what
 * came before — and this heading is where that stops being silent. "Service levels
 * — since Sep 14" is the difference between a number and a lie told by omission:
 * without it, the next reader — a new GM, an insurer, the operator in six months —
 * has no way to know the figures are not what they appear to be.
 *
 * One component for the SLA tiles and both breakdown panels, so the three headings
 * can never disagree about whether a period is in force. The date renders through
 * the shared formatter, in property time like every date in the app.
 */
export function PeriodHeading({ label, baselineAt }: { label: string; baselineAt: string | null }) {
  const { t } = useTranslation();

  return (
    <h2 className="mb-3 text-base font-semibold">
      {baselineAt
        ? t('admin.periodSince', { heading: label, date: formatDayMonth(baselineAt) })
        : label}
    </h2>
  );
}
